import PropTypes from 'prop-types';
import { DoubleSlider } from '@bwoty-web/styleguide';
import CheckboxFilter from "../../shared/filterComponents/CheckboxFilter";
import './destinationFilter.scss';

const DestinationFilter = ({
  filterGroup,
  matches,
  selectDestination,
  selectNumberOfDestinations,
  filterPanelIsOpen,
}) => {
  const {
    id,
    options,
    selected,
    numberOfDestinationsHeading,
    toLabel,
    destinationsLabel,
    minNumberOfDestinations,
    maxNumberOfDestinations,
    selectedMinNumberOfDestinations,
    selectedMaxNumberOfDestinations,
  } = filterGroup;
  return (
    <>
      <CheckboxFilter
        id={id}
        options={options}
        matches={matches}
        selected={selected}
        onChange={selectDestination}
        key={id}
      />
      {minNumberOfDestinations !== maxNumberOfDestinations && <>
        <div className="iw-cruise-destination-filter__n-of-destinations-heading">{numberOfDestinationsHeading}</div>
        <DoubleSlider
          hidden={!filterPanelIsOpen}
          uniqueId={`doubleslider-${filterGroup.id}`}
          key={`doubleslider-${filterGroup.id}`}
          filterSliderToLabel={toLabel}
          filterSingularUnitLabel={destinationsLabel}
          filterPluralUnitLabel={destinationsLabel}
          minValue={minNumberOfDestinations}
          maxValue={maxNumberOfDestinations}
          selectedLowValue={selectedMinNumberOfDestinations != null ? selectedMinNumberOfDestinations : minNumberOfDestinations}
          selectedHighValue={selectedMaxNumberOfDestinations != null ? selectedMaxNumberOfDestinations : maxNumberOfDestinations}
          onChangeComplete={(selectedValues) =>
            selectNumberOfDestinations(
              selectedValues.lowValue,
              selectedValues.highValue,
            )
          }
        />
      </>} 
    </>
  );
};

DestinationFilter.propTypes = {
  filterGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    options: PropTypes.arrayOf({}).isRequired,
    minNumberOfDestinations: PropTypes.number.isRequired,
    maxNumberOfDestinations: PropTypes.number.isRequired,
    selected: PropTypes.arrayOf().isRequired,
    selectedMinNumberOfDestinations: PropTypes.number.isRequired,
    selectedMaxNumberOfDestinations: PropTypes.number.isRequired,
    numberOfDestinationsHeading: PropTypes.string.isRequired,
    toLabel: PropTypes.string.isRequired,
    destinationsLabel: PropTypes.string.isRequired,
  }).isRequired,
  matches: PropTypes.shape().isRequired,
  selectDestination: PropTypes.func.isRequired,
  selectNumberOfDestinations: PropTypes.func.isRequired,
  filterPanelIsOpen: PropTypes.bool.isRequired,
};

export default DestinationFilter;